<template>
    <div class="box">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>翻译管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true"  class="user-search" style="text-align: left;padding-top: 20px">
            <el-form-item label="" prop="SearchKey">
                <el-input  placeholder="请输入关键词" v-model="model.SearchKey" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button  type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button  type="primary" icon="el-icon-plus" @click="handleAdd()">添加</el-button>
            </el-form-item>
        </el-form>
        <!-- 列表 -->
        <el-table border default-expand-all :data="dataList" style="width: 100%"   highlight-current-row
            :default-sort="{prop: 'date', order: 'descending'}">
            <el-table-column align="center" type="selection" width="50">
            </el-table-column>
            <el-table-column prop="Chinese" label="中文" sortable width="180">
            </el-table-column>
           <el-table-column prop="English" label="英文" sortable width="300">
            </el-table-column>
            <el-table-column label="操作" min-width="300" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                </template>
        </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: left;padding-top: 10px">
            <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page="model.Page"
                layout="total,prev, pager, next, jumper"
                :total="listCount"
                :page-size="model.Rows">
            </el-pagination>
        </el-row>
        <add v-if="isShowAdd" :dialogFormVisible="isShowAdd" @closeAddDialog="handleCloseAdd"></add>
        <edit v-if="isShowEdit" :dialogFormVisible="isShowEdit" @closeEditDialog="handleCloseEdit" :data="editData"></edit>
    </div>
</template>

<script>
    import {GetTranslationList,DeleteFieldTranslation} from '../../api/translate'
    import add from './add'
    import edit from './edit'
    export default {
        components: {
            add,
            edit
        },
        data() {
            return {
                isShowAdd: false,
                isShowEdit: false,
                listCount: null,
                dataList: [],
                editData: [],
                model: {
                    Page: 1,
                    Rows: 10,
                    SearchKey: ''
                },
            }
        },
        watch: {
            'model.SearchKey': {
                handler(newVal) {
                    if(newVal === '') {
                        this.model.SearchKey = '';
                        this.GetTranslationList();
                    }
                }
            }
        },
        filters: {
            filterLogo(logo) {
                if(logo) {
                    return logo.split()
                }
            },
            filterImgs(images) {
                if(typeof(images)==='string') {
                    if(images.indexOf('|')!=-1) {
                        return images.split('|');
                    }else{
                        return images.split(' ');
                    }  
                }
            }
        },
        mounted() {
            this.GetTranslationList();
        },
        methods: {
            GetTranslationList() {
                GetTranslationList(this.model).then(data=>{
                    if(!data.iserror) {
                        this.dataList = data.data.List;
                        this.listCount = data.data.Count;
                    }
                })
            },
            handleCurrentChange(val) {
                this.model.Page = val;
                this.GetTranslationList();
            },
            handleSearch() {
                if(this.model.SearchKey === '') {
                    this.$message({
                        message: '搜索内容不能为空',
                        type: 'warning'
                    });
                    return false;
                }
                this.model.Page = 1;
                this.GetTranslationList();
            },
            handleAdd() {
                this.isShowAdd = true;
            },
            handleEdit(row) {
                this.editData = row;
                this.isShowEdit = true;
            },
            handleDelete(row) {
                let id = row.OID;
                this.$confirm('确认删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    this.DeleteFieldTranslation(id);
                })
            },
            handleCloseEdit() {
                this.isShowEdit = false;
                this.GetTranslationList();
            },
            handleCloseAdd() {
                this.isShowAdd = false; 
                this.GetTranslationList();
            },
            DeleteFieldTranslation(id) {
                DeleteFieldTranslation({OID: id}).then(data=>{
                    if(!data.iserror) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.GetTranslationList();
                    }
                })
            }
        }
    }
</script>

<style>
.el-icon-circle-close:before {
    color: #ffffff;
}
</style>